import type { BudgetDisplay } from "@msc/shared";

/**
 * Die drei Felder einer Agenda-Vorlage, die sich im Panel bearbeiten lassen
 * (Spec D9) — ohne `kind`/`segmentId`/`isOverride`, die den Datensatz nur
 * identifizieren, nicht seinen Inhalt.
 */
export interface EditableAgendaTemplate {
  title: string;
  body: string;
  budgetDisplay: BudgetDisplay;
}

/**
 * Rein: Weicht die bearbeitete Fassung vom geladenen Stand ab?
 *
 * Steuert den „Speichern"-Knopf im Vorlagen-Panel — er bleibt deaktiviert,
 * solange nichts geändert wurde, damit ein Klick nie einen No-op-Request
 * auslöst. Dasselbe Muster wie `dirty` in `FrequencyRow` (`routes/settings.tsx`),
 * hier als eigene Funktion, weil drei Felder statt einem verglichen werden.
 */
export function dirtyTemplate(orig: EditableAgendaTemplate, edited: EditableAgendaTemplate): boolean {
  return (
    orig.title !== edited.title ||
    orig.body !== edited.body ||
    orig.budgetDisplay !== edited.budgetDisplay
  );
}
